import { render, staticRenderFns } from "./IconBell.vue?vue&type=template&id=2dcb8dd8"
import script from "./IconBell.vue?vue&type=script&lang=ts"
export * from "./IconBell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports